import React from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { td } from '@/lib/i18n';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { fetchPhotoSubmissions } from '@/services/photo-submission';
export const Route = createFileRoute('/console/_authenticated/_layout/internal/_layout/photos/')({
    component: PhotosList,
});
function PhotosList() {
    const { t } = useTranslation('internal');
    const { data: photos = [], isLoading } = useQuery({
        queryKey: ['photo-submissions'],
        queryFn: () => fetchPhotoSubmissions(),
    });
    return (<div className="flex flex-col gap-6 p-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-semibold">{t('photos.title')}</h1>
                    <p className="text-sm text-muted-foreground">{t('photos.subtitle')}</p>
                </div>
                <Button asChild>
                    <Link to="/console/internal/photos/new">
                        <Plus className="h-4 w-4"/>
                        {t('photos.log')}
                    </Link>
                </Button>
            </div>

            {isLoading ? (<p className="text-sm text-muted-foreground">{t('common.loading')}</p>) : photos.length === 0 ? (<Card>
                    <CardHeader>
                        <CardTitle>{t('photos.empty_title')}</CardTitle>
                        <CardDescription>{t('photos.empty_desc')}</CardDescription>
                    </CardHeader>
                </Card>) : (<div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
                    {photos.map((photo) => {
                const src = photo.imageCardUrl ?? photo.imageThumbnailUrl ?? photo.imageUrl;
                return (<Card key={photo.publicId}>
                            <CardContent className="p-3 space-y-2">
                                {src ? (<img src={src} alt={`Submission ${photo.publicId}`} className="w-full aspect-square object-cover rounded-md" loading="lazy"/>) : (<div className="w-full aspect-square bg-muted rounded-md"/>)}
                                <div className="text-xs text-muted-foreground space-y-0.5">
                                    <p>
                                        {photo.periodStart.slice(0, 10)} → {photo.periodEnd.slice(0, 10)}
                                    </p>
                                    <p>
                                        {t('photos.via_label', {
                        source: td(t, `enum.submission_via.${photo.submittedVia}`),
                    })}
                                    </p>
                                    {photo.submittedByEmail && (<p>{t('photos.by_label', { email: photo.submittedByEmail })}</p>)}
                                </div>
                            </CardContent>
                        </Card>);
            })}
                </div>)}
        </div>);
}
